export default __webpack_public_path__ + "static/media/google-play-logo.9bb4b000.webp";